/**
 * Toggle MXN | USD del header + etiqueta con la tasa de cambio usada.
 *
 * El markup vive en el HTML (espejo de los botones .grain):
 *   <span class="cur-toggle" id="curToggle">
 *     <button data-cur="MXN">MXN</button>
 *     <button data-cur="USD">USD</button>
 *   </span>
 *   <span class="cur-rate" id="curRate"></span>
 *
 * Al cambiar de moneda persiste la elección, repinta el estado activo, dispara
 * el evento global 'dashboard:currency-changed' y llama al callback onChange.
 */

import { $ } from '../utils/dom.js';
import { getDisplayCurrency, setDisplayCurrency, getCachedRates } from '../currencyStore.js';
import { usdToMxn } from '../utils/currency.js';

export const CURRENCY_CHANGED_EVENT = 'dashboard:currency-changed';

export function renderCurrencyToggle() {
  const wrap = $('curToggle');
  if (!wrap) return;
  const active = getDisplayCurrency();
  wrap.querySelectorAll('button[data-cur]').forEach((b) => {
    b.classList.toggle('active', b.dataset.cur === active);
  });
}

export function bindCurrencyToggle(onChange) {
  const wrap = $('curToggle');
  if (!wrap) return;
  wrap.querySelectorAll('button[data-cur]').forEach((b) => {
    b.onclick = () => {
      const code = b.dataset.cur;
      if (code === getDisplayCurrency()) return;
      setDisplayCurrency(code);
      renderCurrencyToggle();
      window.dispatchEvent(new Event(CURRENCY_CHANGED_EVENT));
      if (typeof onChange === 'function') onChange();
    };
  });
}

/** Refresca el texto "1 USD = $X MXN · fecha" cuando llegan/cambian las tasas. */
export function renderRateLabel() {
  const el = $('curRate');
  if (!el) return;
  const rate = usdToMxn();
  const cached = getCachedRates();
  let suffix = '';
  if (cached && cached.ts) {
    const d = new Date(cached.ts).toLocaleDateString('es-MX', { day: 'numeric', month: 'short' });
    suffix = cached.source === 'manual' ? ' · manual' : ` · ${d}`;
  }
  el.textContent = `1 USD = ${rate.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 2 })} MXN${suffix}`;
}
